import styled from "styled-components";
import {DenmarkResponsibleGamingButtonBaseBox} from "../../boxes/denmark.responsible-gaming-button-base.box";

export const DenmarkSafeToPlayButtonBox = styled(DenmarkResponsibleGamingButtonBaseBox)`
    width: 40px;
    height: 40px;
    
    @media ${({theme}) =>  theme.mediaQuery.sAndBelow} {
        width: 25px;
        height: 25px;
    }
`